import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

import TwitterIcon from "assets/icons/social-media/TwitterIcon";
import FacebookIcon from "assets/icons/social-media/FacebookIcon";
import InstagramIcon from "assets/icons/social-media/InstagramIcon";
import LinkedinIcon from "assets/icons/social-media/LinkedinIcon";
import YoutubeIcon from "assets/icons/social-media/YoutubeIcon";

function Footer({ isEnglish, handleSwitchLanguage }) {
  const { t } = useTranslation();

  return (
    <div className="relative text-white bg-app-dark-blue">
      <div className="flex flex-col justify-between gap-6 app-nav-container sm:flex-row sm:gap-0">
        <div className="grid grid-cols-1 gap-6 text-sm sm:grid-cols-3 sm:gap-12 md:text-base xl:text-lg">
          <div className="flex flex-col items-start space-y-2 sm:items-start xl:space-y-4">
            <img
              src={
                "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/440c944b85a834697bbd2d6d1e59365c9e62c8aee2cd3b46098227a3b68a946610915f39c279aaec55a149eb2d3009ca2f0be2e122f81250a4f7266fef2bdb548aa6bda5e6e74f4fc034e8aba639e6c682f83d3364d4c00ca106b865f8caf8bc0f3a277afc36048a9339c4f580faea909e049a4889c56d5d7de6/file-1739774789648.png"
              }
              alt="logo"
              className="w-1/2 sm:w-full lg:w-3/4"
            />
            <ul className="py-4 space-y-2 sm:pl-2 xl:space-y-4">
              <li>
                <a href="/our-team">Our Team</a>
              </li>
              <li>
                <a href="/contact-us">Contact Us</a>
              </li>
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/refund-policy">Refund Policy</a>
              </li>
            </ul>
          </div>
          <ul className="space-y-2 xl:space-y-4">
            <li>
              <a href="/services/diploma-project-management-esg">
                Diploma of Project Management for ESG Projects with Australia
                Certification
              </a>
            </li>
            <li>
              <a href="/services/leadership-sustainability">
                Leadership in Sustainability
              </a>
            </li>
            <li>
              <a href="/services/esg-workshop-training">
                ESG Workshop & Inhouse Training Topics
              </a>
            </li>
            <li>
              <a href="/services/csr-workshop-training">
                CSR Workshop & Inhouse Training Topics
              </a>
            </li>
            <li>
              <a href="/services/social-entrepreneurship-workshop-training">
                Social Entrepreneurship Workshop & Inhouse Trainings
              </a>
            </li>
          </ul>
          <div className="flex flex-col items-start space-y-2 sm:items-end xl:space-y-4">
            <p className="text-sm font-normal uppercase md:text-base xl:text-lg">
              FOLLOW US
            </p>
            <div className="flex flex-row gap-2 sm:gap-4">
              <a
                href="https://www.instagram.com/isa.academy.id"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon className="w-5 h-5 fill-white md:h-6 xl:h-8 md:w-6 xl:w-8" />
              </a>
              <a
                href="https://www.linkedin.com/company/isa-academy-inhocsigno-hominum-salvator"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedinIcon className="w-5 h-5 fill-white md:h-6 xl:h-8 md:w-6 xl:w-8" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center gap-8 app-nav-container sm:flex-row lg:justify-start lg:items-end">
        {/* <div>
          <label className="relative inline-flex items-center cursor-pointer ">
            <span className="text-xs font-medium me-3 md:text-sm text-white-900 dark:text-white-300">ID</span>
            <input
              type="checkbox"
              value={isEnglish}
              checked={isEnglish}
              onChange={() => handleSwitchLanguage()}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-red-300 dark:peer-focus:ring-red-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[26px] sm:after:start-[26px] md:after:start-[28px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
            <span className="text-xs font-medium ms-3 md:text-sm text-white-900 dark:text-white-300">EN</span>
          </label>
        </div> */}
        <div className="text-xs md:text-sm">
          <p>
            {moment().year()} PT Inhocsigno Hominum Salvator. All Rights
            Reserved.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
